<p>
  14. КОНСТРУКТОР ОПЕРАЦИЙ (МОДУЛЬ БИЗНЕС-ПРОЦЕССА)
</p>
